import React from 'react';
import { __ } from '@wordpress/i18n';
import { H2 } from '../../ui/style';
import NextStepLink from '../../components/util/next-step-link/index';
import PreviousStepLink from '../../components/util/previous-step-link/index';
import DefaultStep from '../../components/default-step/index'
import ProgressBar from '../../components/progress-bar/index';
import SearchLocation from "../../components/autocomplete";
import ImagePreview from '../../components/image-preview/index';
import { getPlaceDetails, getPhotoUrl, downloadImage } from "../../components/autocomplete/utils";
import { v4 as uuidv4 } from 'uuid';
import PoweredByGoogle from './powered-by-google.png';
import { useStateValue } from '../../store/store';

const sessionToken = uuidv4();

function updatePlaceDetails(storedState, place_id) {
	const [{ businessAddress, businessName, businessPhone, placeDetails, websiteType }, dispatch] = storedState;

	place_id = place_id || placeDetails.place_id;

	getPlaceDetails(place_id, sessionToken).then(response => {
		const newPlaceDetails = { ...placeDetails, ...response };
		dispatch({
			type: 'set',
			placeDetails: newPlaceDetails,
			businessAddress: response.address ? response.address : businessAddress,
			businessName: response.name ? response.name : businessName,
			businessPhone: response.phone_number ? response.phone_number : businessPhone,
			hasBusinessInfo: true,
		})
	});
}

const BusinessSearch = () => {
	const buildPath = starterTemplates.buildDir;
	const googleImageUrl = `${buildPath}${PoweredByGoogle}`;
	const storedState = useStateValue();
	const [{ currentIndex }, dispatch] = useStateValue();

	return (
		<DefaultStep
			content={
				<>
					<H2>{__('Search your Business on Google', 'astra-sites')}</H2>
					<SearchLocation sessionToken={sessionToken} onInputChange={(event, value) => {
						if (value) {
							updatePlaceDetails(storedState, value.place_id)

							dispatch({
								type: 'set',
								currentIndex: currentIndex + 1,
							});
						}
					}} />
				</>
			}
			actions={
				<>
					<PreviousStepLink before>{__('Back', 'astra-sites')}</PreviousStepLink>
					<ProgressBar />
					<NextStepLink ml1 after onClick={(event) => {
						updatePlaceDetails(storedState)
					}}>{__('Next', 'astra-sites')}</NextStepLink>
				</>
			}
			preview={
				<>
					<ImagePreview fileName='step-3.png' />
					<img
						className="powered-by-google-logo"
						src={googleImageUrl}
						alt={__("Powered By Google logo", "astra-sites")}
					/>
				</>
			}
		/>
	)
}

export default BusinessSearch;
